/* SofaMix — Iframe Bridge (clean + safe)
  - PRICE_UPDATE + ORDER_SUBMIT din iframe
  - adaugă produsul în cart cu properties curate (fără linkuri/imagini uriașe)
  - fluxuri:
      A) Add -> Cart   (recomandat)
      B) Add -> Draft -> Checkout (dacă SOFAMIX_USE_DRAFT_ORDER = true)
  - compatibil cu flag-uri:
      SOFAMIX_GO_TO_CART_AFTER_ADD
      SOFAMIX_REDIRECT_THROUGH_CART
      SOFAMIX_CLEAR_CART_BEFORE_ORDER
*/

(() => {
  "use strict";

  if (window.__SOFAMIX_IFRAME_BRIDGE_LOADED__) return;
  window.__SOFAMIX_IFRAME_BRIDGE_LOADED__ = true;

  const DRAFT_ENDPOINT =
    window.SOFAMIX_DRAFT_ENDPOINT ||
    "https://draft.sofamix.ro/iframe_draft_order.php";

  const USE_DRAFT = window.SOFAMIX_USE_DRAFT_ORDER === true;
  const CLEAR_CART = window.SOFAMIX_CLEAR_CART_BEFORE_ORDER === true;

  const GO_TO_CART =
    window.SOFAMIX_GO_TO_CART_AFTER_ADD === true ||
    window.SOFAMIX_REDIRECT_THROUGH_CART === true;

  // Dacă setezi whitelist, îl respectăm.
  // Dacă NU setezi, nu blocăm nimic.
  const ALLOWED_ORIGINS = Array.isArray(window.SOFAMIX_ALLOWED_ORIGINS)
    ? window.SOFAMIX_ALLOWED_ORIGINS
    : null;

  let lastPrice = null;
  let isProcessing = false;

  const PRICE_TYPES = new Set(["PRICE_UPDATE", "CONFIG_PRICE", "PRICE"]);
  const ORDER_TYPES = new Set(["ORDER_SUBMIT", "ADD_TO_CART", "ORDER"]);

  const clampString = (val, max = 180) => {
    if (val == null) return "";
    const s = String(val).trim();
    if (!s) return "";
    return s.length > max ? s.slice(0, max) + "…" : s;
  };

  const safeJsonStringify = (obj, max = 1400) => {
    if (!obj) return "";
    try {
      const s = JSON.stringify(obj);
      if (!s) return "";
      return s.length <= max ? s : "";
    } catch {
      return "";
    }
  };

  const normalizePrice = (p) => {
    if (p == null) return null;
    if (typeof p === "number" && Number.isFinite(p)) return p;

    const s = String(p).trim().replace(/\s/g, "");
    const cleaned = s.replace(/\.(?=\d{3}(\D|$))/g, "");
    const m = cleaned.match(/(\d+[.,]?\d*)/);
    if (!m) return null;

    const v = parseFloat(m[1].replace(",", "."));
    return Number.isFinite(v) ? v : null;
  };

  const safeGet = (obj, path) => {
    try {
      return path.split(".").reduce(
        (o, k) => (o && o[k] != null ? o[k] : undefined),
        obj
      );
    } catch {
      return undefined;
    }
  };

  const extractConf = (msg) =>
    msg?.data?.configuratie ??
    msg?.data?.config ??
    msg?.configuratie ??
    msg?.config ??
    null;

  const extractName = (msg) =>
    msg?.data?.numeProdus ??
    msg?.data?.productName ??
    msg?.numeProdus ??
    msg?.productName ??
    "";

  const extractPrice = (msg) => {
    const conf = extractConf(msg);

    const candidates = [
      msg?.price,
      msg?.data?.price,
      msg?.data?.pret,
      msg?.data?.pretTotal,
      msg?.data?.totalPrice,

      safeGet(conf, "pret"),
      safeGet(conf, "pretTotal"),
      safeGet(conf, "totalPrice"),
      safeGet(conf, "price")
    ];

    for (const c of candidates) {
      const n = normalizePrice(c);
      if (n != null) return n;
    }

    return lastPrice;
  };

  
  const buildProperties = (msg) => {
    const conf = extractConf(msg);
    const proName = clampString(extractName(msg), 120);

    const priceNum = extractPrice(msg);
    const priceStr = priceNum != null ? String(priceNum) : "";

    const props = {};

    // interne, folosite de temă/JS
    if (priceStr) props["__iframe_product_price"] = priceStr;
    if (proName) props["__iframe_product_name"] = proName;

    // IMPORTANT: NU mai stocăm imagine/link în properties,
    // ca să evităm 400/413 la /cart/add.js

    // JSON doar dacă e mic
    const json = safeJsonStringify(conf, 1400);
    if (json) props["_iframe_data"] = json;

    // user-friendly (scurt)
    if (proName) props["Produs configurat"] = proName;

    if (conf) {
      const setIf = (label, val) => {
        const v = clampString(val, 80);
        if (v) props[label] = v;
      };

      setIf("Lungime", safeGet(conf, "canapea.lungime"));
      setIf("Adâncime", safeGet(conf, "canapea.adancime"));

      setIf("Cotiere", safeGet(conf, "cotiere.model"));
      setIf("Grosime cotiere", safeGet(conf, "cotiere.grosime"));

      const husabil = safeGet(conf, "cotiere.husabil");
      if (husabil != null) props["Dehusabil"] = husabil ? "Da" : "Nu";

      setIf("Șezut", safeGet(conf, "sezut.model"));
      setIf("Perne șezut", safeGet(conf, "sezut.numarPerne"));

      setIf("Picioare", safeGet(conf, "picioare.model"));
      setIf("Material picioare", safeGet(conf, "picioare.material"));

      setIf("Confort", safeGet(conf, "confort.model"));
      setIf("Material tapițerie", safeGet(conf, "material.material"));

      setIf("Perne spătar", safeGet(conf, "perne.model"));
      setIf("Nr. perne spătar", safeGet(conf, "perne.numarPerne"));

      // colțare
      const nameLower = (proName || "").toLowerCase();
      if (nameLower.includes("coltar l")) {
        setIf("Șezlong", safeGet(conf, "sezlong.0.lungime"));
      }
      if (nameLower.includes("coltar u")) {
        setIf("Șezlong stânga", safeGet(conf, "sezlong.0.lungime"));
        setIf("Șezlong dreapta", safeGet(conf, "sezlong.1.lungime"));
      }
    }

    return props;
  };
/*
 const buildProperties = (msg) => {
    const conf = extractConf(msg);
    const proName = clampString(extractName(msg), 120);

    const priceNum = extractPrice(msg);
    const priceStr = priceNum != null ? String(priceNum) : "";

    const props = {};

    if (priceStr) props["Preț"] = priceStr;

    // JSON doar dacă e mic
    const json = safeJsonStringify(conf, 1400);
    if (json) props["_iframe_data"] = json;

    // user-friendly (scurt)
    if (proName) props["Produs configurat"] = proName;

    if (conf) {
      const setIf = (label, val) => {
        const v = clampString(val, 80);
        if (v) props[label] = v;
      };

      setIf("Lungime", safeGet(conf, "canapea.lungime"));
      setIf("Adâncime", safeGet(conf, "canapea.adancime"));

      setIf("Cotiere", safeGet(conf, "cotiere.model"));
      setIf("Grosime cotiere", safeGet(conf, "cotiere.grosime"));

      const husabil = safeGet(conf, "cotiere.husabil");
      if (husabil != null) props["Dehusabil"] = husabil ? "Da" : "Nu";

      setIf("Șezut", safeGet(conf, "sezut.model"));
      setIf("Perne șezut", safeGet(conf, "sezut.numarPerne"));

      setIf("Picioare", safeGet(conf, "picioare.model"));
      setIf("Material picioare", safeGet(conf, "picioare.material"));

      setIf("Confort", safeGet(conf, "confort.model"));
      setIf("Material tapițerie", safeGet(conf, "material.material"));

      setIf("Perne spătar", safeGet(conf, "perne.model"));
      setIf("Nr. perne spătar", safeGet(conf, "perne.numarPerne"));

      // colțare
      const nameLower = (proName || "").toLowerCase();
      if (nameLower.includes("coltar l")) {
        setIf("Șezlong", safeGet(conf, "sezlong.0.lungime"));
      }
      if (nameLower.includes("coltar u")) {
        setIf("Șezlong stânga", safeGet(conf, "sezlong.0.lungime"));
        setIf("Șezlong dreapta", safeGet(conf, "sezlong.1.lungime"));
      }
    }

    return props;
  };
*/
  const ensureVariantId = (raw) => {
    const v = String(raw ?? "").trim();
    if (/^\d+$/.test(v)) return v;
    return null;
  };

  const addToCart = async (productId, variantId, properties) => {
  
    // nu sterge pid si vid - pt tracking checkout -- datareshape
    const body = JSON.stringify({
      items: [{ id: parseInt(variantId, 10), quantity: 1, properties: {...properties,...{PID:productId, VID:variantId}} }]
    });

    console.log("[SofaMix] payload bytes:", body.length);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
     },
      credentials: "same-origin",
      body  // ← direct, nu bodyStr
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      console.error("[SofaMix] cart/add error response:", txt);
      throw new Error("cart/add failed: " + txt);
    }
    return res.json();

  };
/*
  const addToCart = async (variantId, properties) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties
      })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error("cart/add failed: " + txt);
    }
    return res.json();
  };
*/
  const clearCart = async () => {
    const res = await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    });
    if (!res.ok) throw new Error("cart/clear failed");
    return res.json();
  };

  const getCartJson = async () => {
    const res = await fetch("/cart.json", {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    });
    if (!res.ok) throw new Error("cart.json failed");
    return res.json();
  };

  const createDraftOrder = async (cartData) => {
    const res = await fetch(DRAFT_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(cartData)
    });

    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      return { raw: text };
    }
  };

  const fireGtagAddToCart = (variantId, msg) => {
    try {
      if (!window.gtag) return;

      const priceNum = extractPrice(msg);
      const name = clampString(extractName(msg), 120) || "Produs configurat";

      // Dacă nu avem preț sigur, trimitem eventul fără value/price
      const payload = {
        currency: "RON",
        items: [{
          item_id: String(variantId),
          item_name: name,
          quantity: 1
        }]
      };

      if (priceNum != null) {
        payload.value = priceNum;
        payload.items[0].price = priceNum;
      }

      window.gtag("event", "add_to_cart", payload);
    } catch (e) {}
  };

  window.addEventListener("message", async (event) => {
    const msg = event.data;
    if (!msg || typeof msg !== "object") return;

    if (ALLOWED_ORIGINS && !ALLOWED_ORIGINS.includes(event.origin)) {
      return;
    }

    if (PRICE_TYPES.has(msg.type)) {
      const p = extractPrice(msg);
      if (p != null) lastPrice = p;
      return;
    }

    if (!ORDER_TYPES.has(msg.type)) return;

    if (isProcessing) return;
    isProcessing = true;

    try {
      const variantId =
        ensureVariantId(msg?.data?.variantId) ||
        ensureVariantId(msg?.variantId) ||
        ensureVariantId(window.SOFAMIX_VARIANT_ID);

      if (!variantId) {
        console.warn("[SofaMix] Lipsă variantId valid.");
        return;
      }

      const productId = ensureVariantId(window.SOFAMIX_PRODUCT_ID);

      if (CLEAR_CART) {
        await clearCart();
      }

      const properties = buildProperties(msg);

      await addToCart(productId, variantId, properties);

      // GA4 add_to_cart (configurator)
      fireGtagAddToCart(variantId, msg);

      // Flux B: Draft direct din iframe (doar dacă îl activezi explicit)
      if (USE_DRAFT && DRAFT_ENDPOINT) {
        const cartData = await getCartJson();
        const draftResp = await createDraftOrder(cartData);

        const invoiceUrl =
          draftResp?.draft_order?.checkout_url ||
          draftResp?.checkout_url ||
          draftResp?.draft_order?.invoice_url ||
          draftResp?.invoice_url;

        window.location.href = invoiceUrl || "/checkout";
        return;
      }

      // Flux A: Add -> Cart (recomandat)
      if (GO_TO_CART) {
        setTimeout(() => {
          window.location.href = "/cart";
        }, 200);
        return;
      }

      // fallback
      window.location.href = "/checkout";
    } catch (e) {
      console.error("[SofaMix] Bridge error:", e);
      window.location.href = "/cart";
    } finally {
      isProcessing = false;
    }
  });
})();
